/**
 * @generated SignedSource<<ec0d4370136c7d64816825e99dfc47b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchListItemContent_StoreProductExpireBatch$data = {
  readonly expireAtDate: {
    readonly isoString: string;
  };
  readonly id: string;
  readonly product: {
    readonly id: string;
    readonly imageUrl: string | null;
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "ProductExpireBatchListItemContent_StoreProductExpireBatch";
};
export type ProductExpireBatchListItemContent_StoreProductExpireBatch$key = {
  readonly " $data"?: ProductExpireBatchListItemContent_StoreProductExpireBatch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItemContent_StoreProductExpireBatch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchListItemContent_StoreProductExpireBatch",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProductExpireBatch",
  "abstractKey": null
};
})();

(node as any).hash = "8ae0cae9674c2dc131a826ef57f65861";

export default node;
